import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Phone, Mail, Loader2 } from 'lucide-react';

const RHContactPage = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const handleSend = async () => {
    if (!message.trim()) { toast.error('Digite uma mensagem'); return; }
    setSending(true);
    try {
      await axios.post(`${API}/contact/send`, { subject: subject || 'Contato Empresa', message, sender_type: 'company' });
      toast.success('Mensagem enviada!');
      setSubject(''); setMessage('');
    } catch { toast.error('Erro ao enviar'); }
    finally { setSending(false); }
  };
  return (
    <div className="space-y-6" data-testid="rh-contact-page">
      <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Chivo, sans-serif' }}>Contato</h1>
      <Card className="border-slate-100">
        <CardContent className="p-6 space-y-4">
          <p className="text-sm text-slate-600">Envie uma mensagem para a administração Vital Performance</p>
          <p className="text-xs text-slate-400">E-mail: contato@vitalperformance.app.br</p>
          <Input value={subject} onChange={e => setSubject(e.target.value)} placeholder="Assunto" data-testid="rh-contact-subject" />
          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Digite sua mensagem..." rows={5}
            className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" data-testid="rh-contact-message" />
          <Button onClick={handleSend} disabled={sending} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="rh-contact-send">
            {sending ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}Enviar Mensagem
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

// ==================== COMPANY PROFILE ====================

export default RHContactPage;
